import React, { useMemo } from 'react';
import { useTranslator } from 'tradera/lang/translate';
import PropTypes from 'prop-types';
import Tags from '../tags/tags';
import HotIcon from '@tradera/blueprint/theme/icons2/hot.svg?jsx';
import css from './trending-searches-tags.module.scss';
import { useGetTrendingSearchesQuery } from 'tradera/state/services/discover-api';

const mapNameAndUrl = (trendingSearch) => ({
    ...trendingSearch,
    name: trendingSearch.query || '',
    url: `/search?q=${trendingSearch.query}${
        trendingSearch.categoryId
            ? `&categoryId=${trendingSearch.categoryId}`
            : ''
    }&sortBy=MostBids`
});

const TrendingSearchesTags = ({ className, inHeader }) => {
    const { t } = useTranslator();
    const { data } = useGetTrendingSearchesQuery();

    const trendingSearches = useMemo(
        () => (data || []).map(mapNameAndUrl),
        [data]
    );

    const tags = useMemo(
        () =>
            limitTags(inHeader ? 7 : trendingSearches.length, trendingSearches),
        [inHeader, trendingSearches]
    );

    if (!tags || tags.length === 0) {
        return null;
    }

    return (
        <div
            className={`${
                inHeader ? `${css.inHeader}` : 'mt-2 pb-2 ml-2 ml-lg-0'
            } ${className}`}>
            <Tags
                gaCategory="Trending Searches"
                gaAction="Navigation"
                tags={tags}
                scroll={!inHeader}>
                {inHeader ? (
                    <span
                        className={`mr-1 mr-md-0 text-styled text-light align-text-bottom ${css.textShadow}`}>
                        {t('trendingTags_searches')}
                    </span>
                ) : (
                    <HotIcon
                        className="icon icon-sm flex-shrink-0 mr-1"
                        alt={t('trendingTags_searches')}
                    />
                )}
            </Tags>
        </div>
    );
};

const limitTags = (limit, trendingSearches) =>
    trendingSearches.slice(0, limit).map((item) => item);

TrendingSearchesTags.defaultProps = {
    className: ''
};

TrendingSearchesTags.propTypes = {
    className: PropTypes.string,
    inHeader: PropTypes.bool.isRequired
};

export default TrendingSearchesTags;
